var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 16.5859V9.91927C10.75 9.69826 10.6622 9.4863 10.5059 9.33002C10.3496 9.17374 10.1377 9.08594 9.91667 9.08594H6.58333C6.36232 9.08594 6.15036 9.17374 5.99408 9.33002C5.8378 9.4863 5.75 9.69826 5.75 9.91927V16.5859",
    stroke: "#4C6484",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 7.41707C0.749942 7.17462 0.802778 6.93509 0.904823 6.71516C1.00687 6.49524 1.15566 6.30023 1.34083 6.14373L7.17417 1.14373C7.47499 0.88949 7.85613 0.75 8.25 0.75C8.64387 0.75 9.02501 0.88949 9.32583 1.14373L15.1592 6.14373C15.3443 6.30023 15.4931 6.49524 15.5952 6.71516C15.6972 6.93509 15.7501 7.17462 15.75 7.41707V14.9171C15.75 15.3591 15.5744 15.783 15.2618 16.0956C14.9493 16.4081 14.5254 16.5837 14.0833 16.5837H2.41667C1.97464 16.5837 1.55072 16.4081 1.23816 16.0956C0.925595 15.783 0.75 15.3591 0.75 14.9171V7.41707Z",
    stroke: "#4C6484",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.69a4cb264dacf43ddcced6b7d6adccda.svg";
export { ForwardRef as ReactComponent };